export default {"src":"/_next/static/media/LAL_logo.9345ef90.svg","height":318,"width":318,"blurWidth":0,"blurHeight":0};